<script setup>
import { computed } from "vue";
import moment from "moment";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number, null], default: null },
  type: { type: String, default: "text" }, // text | date | mono
  full: { type: Boolean, default: false },
  isWithoutField: { type: Boolean, default: false },
});

const display = computed(() => {
  if (props.value === null || props.value === undefined || props.value === "")
    return t("Не указано");
  if (props.type === "date") {
    const m = moment(props.value);
    return m.isValid() ? m.format("DD MMMM YYYY") : props.value;
  }
  return props.value;
});

const isEmpty = computed(
  () => props.value === null || props.value === undefined || props.value === ""
);
</script>

<template>
  <div :class="['flex flex-col  min-w-0', full && 'col-span-full']">
    <span class="text-[12.5px] font-medium text-muted-foreground">{{
      label
    }}</span>
    <div
      v-if="isWithoutField"
      :class="[
        'text-[13px] py-1 break-words whitespace-normal',
        isEmpty
          ? 'text-muted-foreground font-normal'
          : 'text-foreground font-medium',
        type === 'mono' && 'font-mono',
      ]"
    >
      {{ display }}
    </div>
    <div
      v-else
      :class="[
        'flex items-center px-2.5 h-8 text-[13px] break-words border border-input bg-muted/50',
        isEmpty
          ? 'text-muted-foreground font-normal'
          : 'text-foreground font-medium',
        type === 'mono' && 'font-mono',
      ]"
      style="border-radius: var(--radius)"
    >
      {{ display }}
    </div>
  </div>
</template>
